// @flow

import deepFreeze from 'deep-freeze';

type Configs = {|
    debug: boolean,
    app: Object,
    language: Object,
    location: Object,
    session: Object,
    data: Object,
    breakpoints: Object,
    ad: Object,
    articles: Object
|};

// - Debug.
const debug = false;

// - App.
const app = {
    name: `Machines de Chantiers`
};

// - Language
const language = {
    list    : ['fr', 'de', 'it'],
    default : 'fr',
    names   : {
        fr : 'Français',
        de : 'Deutsch',
        it : 'Italiano'
    },
    locale: {
        fr : 'fra',
        de : 'deu',
        it : 'ita'
    }
};

// - Location
const location = {
    base: ''
};

// - Session config.
const session = {
    cookie  : 'auth_token',
    timeout : null // - En jours, `null`: session browser.
};

// $FlowFixMe dataset existe dans les données renvoyées statiquement
const data = typeof dataset !== 'undefined' ? dataset : {}; // eslint-disable-line

// - Screen breakpoints.
const breakpoints = {
    'tablet'        : 544,
    'small-desktop' : 768,
    'desktop'       : 992,
    'large-desktop' : 1200
};

// - Ads config.
const ad = {
    featuredDuration : 30, // - En jours
    priorityDuration : 30 // - En jours
};

// -
const articles = {
    elements: 5
};

export default (deepFreeze({
    debug,
    app,
    language,
    location,
    session,
    data,
    breakpoints,
    ad,
    articles
}): Configs);
